import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { Link } from 'react-router-dom'
import * as $Clinic from '@services/Clinic'
import { WHATSAPP_NUMBER } from '@constants/contact'

const animatedComponents = makeAnimated()

type OptionType = { value: any; label: string }

export interface IClinicCascadeValue {
  clinic_state: string
  clinic_city: string
  clinic_id: number|''
}

interface ClinicCascadeSelectProps {
  value: IClinicCascadeValue
  onChange: (value: IClinicCascadeValue) => void
}

const ClinicCascadeSelect: React.FC<ClinicCascadeSelectProps> = ({ value, onChange }) => {
  const [ states, setStates ] = useState<OptionType[]>([])
  const [ cities, setCities ] = useState<OptionType[]>([])
  const [ clinics, setClinics ] = useState<OptionType[]>([])

  useEffect(() => {
    $Clinic.states().then(({ data }) => setStates(data))
  }, [])

  useEffect(() => {
    if (value.clinic_state) {
      $Clinic.cities(value.clinic_state).then(({ data }) => setCities(data))
    } else {
      setCities([])
    }
  }, [value.clinic_state])

  useEffect(() => {
    if (value.clinic_city) {
      $Clinic.allByCity(value.clinic_city).then(({ data }) => {
        setClinics(data.map((clinic: any) => ({
          value: clinic.id,
          label: clinic.name || clinic.trading_name,
        })))
      }).catch((error) => {
        console.error('Error fetching clinics:', error)
        setClinics([])
      })
    } else {
      setClinics([])
    }
  }, [value.clinic_city])

  const menuPortalProps = {
    menuPortalTarget: document.body,
    styles: {
      menuPortal: (base: any) => ({ ...base, zIndex: 1000 }),
    },
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-3">
          <div className="form-group">
            <Select
              className="react-select"
              placeholder={<div>UF</div>}
              components={animatedComponents}
              options={states}
              value={states.find((s) => s.value === value.clinic_state) || null}
              onChange={(opt: any) => onChange({ clinic_state: opt?.value || '', clinic_city: '', clinic_id: '' })}
              isClearable={true}
              isSearchable={true}
              closeMenuOnSelect={true}
              {...menuPortalProps}
            />
          </div>
        </div>
        <div className="col-12 col-sm-4">
          <div className="form-group">
            <Select
              className="react-select"
              placeholder={<div>Cidade da Clínica</div>}
              components={animatedComponents}
              options={cities}
              value={cities.find((c) => c.value === value.clinic_city) || null}
              onChange={(opt: any) => onChange({ ...value, clinic_city: opt?.value || '', clinic_id: '' })}
              isClearable={true}
              isSearchable={true}
              isDisabled={!value.clinic_state}
              closeMenuOnSelect={true}
              {...menuPortalProps}
            />
          </div>
        </div>
        <div className="col-12 col-sm-5">
          <div className="form-group">
            <Select
              className="react-select"
              placeholder={value.clinic_city && clinics.length === 0 ? <div>Nenhuma clínica encontrada</div> : <div>Nome da Clínica</div>}
              components={animatedComponents}
              options={clinics}
              value={clinics.find((c) => c.value === value.clinic_id) || null}
              onChange={(opt: any) => onChange({ ...value, clinic_id: opt?.value || '' })}
              isClearable={true}
              isSearchable={true}
              isDisabled={!value.clinic_city}
              closeMenuOnSelect={true}
              {...menuPortalProps}
            />
          </div>
        </div>
      </div>
      <div className="mb-0">
        <small>Não encontrou sua clínica? <Link to={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Não encontrei a minha clínica.')}`} target="_blank"><span>Clique aqui</span></Link></small>
      </div>
    </>
  )
}

export default ClinicCascadeSelect
